import { decodeBetaHandoff } from "@hub";
import { registerBetaTester, setSession } from "./authService";
import { ensureJourneyDb, writeAudit } from "../db";

const CLAIMED_KEY = "dh_beta_claimed";

function claimedTokens() {
  try {
    return JSON.parse(localStorage.getItem(CLAIMED_KEY) || "[]");
  } catch {
    return [];
  }
}

function markClaimed(token) {
  const next = [...new Set([...claimedTokens(), token])].slice(-40);
  localStorage.setItem(CLAIMED_KEY, JSON.stringify(next));
}

export function readBetaHandoffFromLocation(location = window.location) {
  const params = new URLSearchParams(location.search);
  if (params.get("beta") !== "1") return null;
  const token = params.get("handoff");
  if (!token || claimedTokens().includes(token)) return null;
  return { token, profile: decodeBetaHandoff(token) };
}

export async function consumeBetaHandoff(location = window.location) {
  const found = readBetaHandoffFromLocation(location);
  if (!found?.profile) return null;
  ensureJourneyDb();
  const result = await registerBetaTester(found.profile);
  markClaimed(found.token);
  try {
    writeAudit({
      user_id: result.session.userId,
      action_type: "beta.accept",
      metadata: {
        betaRole: result.session.betaRole,
        acceptedAt: result.session.betaAcceptedAt,
        email: result.session.email,
      },
    });
  } catch {
    /* audit is best-effort on first paint */
  }
  setSession(result.session);
  return result;
}

export function stripBetaQuery(navigate) {
  if (typeof window === "undefined") return;
  const url = new URL(window.location.href);
  if (!url.searchParams.has("beta") && !url.searchParams.has("handoff")) return;
  url.searchParams.delete("beta");
  url.searchParams.delete("handoff");
  const next = `${url.pathname}${url.search}${url.hash}`;
  if (navigate) navigate(next, { replace: true });
  else window.history.replaceState({}, "", next);
}
